import React, { Component } from 'react';

export default class RestClientAuthTab extends Component {
  state = {
    authType: this.props.authType,
    accessToken: this.props.accessToken,
    requestHeader: this.props.requestHeader,
  };

  render() {
    return (
      <div className="row pt-2">
        <div className="col-md-3 col-lg-3">Type</div>
        <div className="col-md-3 col-lg-3">Add authorization data to</div>
        <div className="col-md-6 col-lg-6">Access Token</div>

        <div className="col-md-3 col-lg-3">
          <select
            name="authType"
            onChange={this.props.handleAuthData}
            className="form-control form-control-sm custom-select-sm"
            value={this.props.authType}
          >
            <option value="">Type</option>
            <option value="bearer">Bearer</option>
            <option value="">No Auth</option>
          </select>
        </div>
        <div className="col-md-3 col-lg-3">
          <select
            name="requestHeader"
            onChange={this.props.handleAuthData}
            className="form-control form-control-sm custom-select-sm"
            value={this.props.requestHeader}
          >
            <option value="">Request Headers</option>
            <option value="authUrl">Request URL</option>
          </select>
        </div>
        <div className="col-md-6 col-lg-6">
          <input
            onChange={this.props.handleAuthData}
            type="text"
            name="accessToken"
            className="form-control form-control-sm"
            placeholder="Token"
            value={this.props.accessToken}
          />
        </div>
      </div>
    );
  }
}
